import React from 'react';
import * as PropTypes from 'prop-types';
import './_style.scss';
import { MapContactModel } from "../../../Models/communications/ContactModel";

export default function Marker (props) {
	return (
		<div className="marker" style=
			{{
				backgroundImage: `url(${props.markerInfo.icon})`,
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'center',
			}}
		/>
	);
}

Marker.propTypes = {
	markerInfo: PropTypes.shape(MapContactModel)
};
